<div class="date-picker-container bs-enabled" style="position: relative;">
	<input type="text" class="date-picker-input w-100 m-0"
		   readonly
		   [value]="displayValue"
		   placeholder="N/A"
		   (click)="toggleCalendar()"/>
	<i class="far fa-chevron-down" (click)="toggleCalendar()"></i>

	<div *ngIf="isOpen" class="tri-dp-popup" (click)="$event.stopPropagation()">

		<ng-container *ngIf="dateView !== 'Month'">
			<div class="tri-dp-header">
				<span class="tri-dp-nav-btn" (click)="prevMonth()">&#8249;</span>
				<span class="tri-dp-month-label">{{ monthNames[viewMonth] }} {{ viewYear }}</span>
				<span class="tri-dp-nav-btn" (click)="nextMonth()">&#8250;</span>
			</div>
			<div class="tri-dp-weekdays">
				<span *ngFor="let d of weekDays">{{ d }}</span>
			</div>
			<div class="tri-dp-days-grid">
				<div *ngFor="let day of calendarDays; let i = index"
					 class="tri-dp-day"
					 [class.tri-dp-other-month]="!day.currentMonth"
					 [class.tri-dp-today]="day.isToday"
					 [class.tri-dp-disabled]="day.disabled"
					 [class.tri-dp-selected]="dateView === 'Day' && isSelected(day)"
					 [class.tri-dp-week-active]="dateView === 'Week' && isInActiveWeek(day)"
					 [class.tri-dp-week-start]="i % 7 === 0"
					 [class.tri-dp-week-end]="i % 7 === 6"
					 (mouseenter)="onDayHover(day)"
					 (mouseleave)="onDayLeave()"
					 (click)="selectDay(day)">{{ day.date.getDate() }}</div>
			</div>
		</ng-container>

		<ng-container *ngIf="dateView === 'Month'">
			<div class="tri-dp-year-nav">
				<span class="tri-dp-nav-btn" (click)="prevYear()">&#8249;</span>
				<span>{{ viewYear }}</span>
				<span class="tri-dp-nav-btn" (click)="nextYear()">&#8250;</span>
			</div>
			<div class="tri-dp-months-grid">
				<div *ngFor="let m of monthNames; let i = index"
					 class="tri-dp-month-btn"
					 [class.tri-dp-selected]="isSelectedMonth(i)"
					 [class.tri-dp-disabled]="isMonthDisabled(i)"
					 (click)="selectMonth(i)">{{ m }}</div>
			</div>
		</ng-container>

	</div>
</div>
